import React from 'react';
import './FormSection.css';

export interface FormSectionProps extends React.HTMLAttributes<HTMLElement> {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  accentColor?: string;
  density?: 'compact' | 'default' | 'comfortable';
  children: React.ReactNode;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  description,
  icon,
  actions,
  accentColor,
  density = 'default',
  children,
  className = '',
  style,
  ...props
}) => {
  const classNames = ['ui-form-section', `ui-form-section--${density}`, className].filter(Boolean).join(' ');

  return (
    <section
      className={classNames}
      style={
        {
          '--ui-form-section-accent': accentColor || 'var(--color-primary)',
          ...style,
        } as React.CSSProperties
      }
      {...props}
    >
      <div className="ui-form-section__header">
        <div className="ui-form-section__heading">
          <span className="ui-form-section__accent" aria-hidden="true" />
          <div className="ui-form-section__title-group">
            <h2 className="ui-form-section__title">
              {icon ? <span className="ui-form-section__icon">{icon}</span> : null}
              <span>{title}</span>
            </h2>
            {description ? <p className="ui-form-section__description">{description}</p> : null}
          </div>
        </div>
        {actions ? <div className="ui-form-section__actions">{actions}</div> : null}
      </div>

      <div className="ui-form-section__body">{children}</div>
    </section>
  );
};

FormSection.displayName = 'FormSection';
